export const COUNTRY_CODE = [
  {
    label: "+65",
    value: "+65"
  },
  {
    label: "+60",
    value: "+60"
  }
]
